var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIconCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_652_37)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5C9.23929 5 7 7.23929 7 10C7 13.75 12 19.2857 12 19.2857C12 19.2857 17 13.75 17 10C17 7.23929 14.7607 5 12 5ZM12 11.7857C11.0143 11.7857 10.2143 10.9857 10.2143 10C10.2143 9.01429 11.0143 8.21429 12 8.21429C12.9857 8.21429 13.7857 9.01429 13.7857 10C13.7857 10.9857 12.9857 11.7857 12 11.7857Z",
    fill: "#B2022F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_652_37"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIconCart);
export default __webpack_public_path__ + "static/media/location_icon_cart.043a5c88ff2d70234b793b2c21b309e5.svg";
export { ForwardRef as ReactComponent };